// @flow
import React from 'react'


const FcLabel = (props) => (
	<span style={{fontSize:'1.4rem'}}>{props.children}</span>
)
export default FcLabel
